import { formatDate, toFixedNumber } from "../../../base/utils";
import { Uniter } from "../../../helbest";
import styles from "./Transaction.module.css";
import { ReactComponent as ChargedIcon } from "../../../assets/svg/charged.svg";
import { ReactComponent as PaidIcon } from "../../../assets/svg/paid.svg";

const Transaction = ({ data }) => (
  <div className={styles.Container}>
    {data.changedAmount > 0 ? <ChargedIcon /> : <PaidIcon />}
    <div>
      <div className={styles.Row}>
        <div className={styles.Status}>
          <span
            className={data.changedAmount > 0 ? styles.Charged : styles.Paid}
          >
            {data.changedAmount > 0 ? "Charged" : "Paid"}
          </span>
          <span className={styles.Date}>{formatDate(data?.createdAt)}</span>
        </div>
        <Uniter childSize={14} unitSize={10} unit="OMR">
          {Number(toFixedNumber(data.changedAmount))}
        </Uniter>
      </div>
      <p className={styles.Desc}>{data.description}</p>
    </div>
  </div>
);

export default Transaction;
